import coltureIcon from '../Assets/brands/colture.svg';
import daxeIcon from '../Assets/brands/daxe.svg';
import dottylandIcon from '../Assets/brands/dottyland.svg';
import grinIcon from '../Assets/brands/grin.svg';
import hydraIcon from '../Assets/brands/hydradao.svg';
import lumenIcon from '../Assets/brands/lumen.svg';
import metamoonIcon from '../Assets/brands/metamoon.svg';
import seuntIcon from '../Assets/brands/seunt.svg'
import nubiaIcon from '../Assets/brands/nubia.png'
import pulsarIcon from '../Assets/brands/pulsar.svg'
import calciumIcon from '../Assets/brands/calcium.svg'

import buildspace from '../Assets/brands/buildspace.svg';
import gdsc from '../Assets/brands/gdsc.svg';
import andela from '../Assets/brands/andela.svg';
import microsoft from '../Assets/brands/microsoft.svg';
import startupgrind from '../Assets/brands/startupgrind.svg';
import ethglobal from '../Assets/brands/ethglobal.svg';
import google from '../Assets/brands/google.svg';
import osca from '../Assets/brands/osca.svg';


import react from '../Assets/brands/react.svg';
import shard from '../Assets/brands/shard.svg';
import github from '../Assets/brands/github.svg'


export const brandsList = [
	{
		brandName: 'Meta Moon Gaming',
		brandLocation: 'California, USA',
		brandLogo: metamoonIcon,
		link: 'https://www.linkedin.com/company/meta-moon-gaming/?lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BvcPp37XfSOaJ%2Bci7Qb3K%2Bw%3D%3D'
	},

	{
		brandName: 'Calcium',
		brandLocation: 'Global',
		brandLogo: calciumIcon,
		link: 'https://calcium.fitness/'
	},

	// {
	// 	brandName: 'Pulsar Exchange',
	// 	brandLocation: 'Global',
	// 	brandLogo: pulsarIcon,
	// 	link: 'https://www.pulsar.exchange/'
	// },

	{
		brandName: 'Dottyland',
		brandLocation: 'Talinn, Estonia',
		brandLogo: dottylandIcon,
		link: 'https://dottyland.xyz/'
	},

	{
		brandName: 'Hydra DAO',
		brandLocation: 'Singapore - Japan',
		brandLogo: hydraIcon,
		link: ''
	},

	{
		brandName: 'Colture',
		brandLocation: 'Lekki. Lagos, Nigeria',
		brandLogo: coltureIcon,
		link: 'https://colturemgt.com/'
	},

	// {
	// 	brandName: 'Daxe',
	// 	brandLocation: 'British Columbia, Canada',
	// 	brandLogo: daxeIcon,
	// 	link: 'https://daxetoken.net/'
	// },

	{
		brandName: 'GrinStvduos',
		brandLocation: 'Nigeria',
		brandLogo: grinIcon
	},

	{
		brandName: 'Seun T Reacts - Africontinent',
		brandLocation: 'Nigeria',
		brandLogo: seuntIcon,
		link: 'https://www.youtube.com/@SeunTReacts'
	},

	{
		brandName: 'Lumen',
		brandLocation: 'Nigeria',
		brandLogo: lumenIcon,
		link: 'https://github.com/lumen-corp'
	},

	{
		brandName: 'Nubiamania',
		brandLocation: 'Nigeria',
		brandLogo: nubiaIcon,
		link: 'https://nubiamania.onrender.com/'
	},
]


export const programList = [{
		brandName: 'Microsoft for startup founders hub member',
		brandLocation: 'Worldwide',
		brandLogo: microsoft,
		link: 'https://www.microsoft.com/en/startups'
	},

	{
		brandName: 'ETHGlobal. 3x participant. 2x hackathon prize winner.',
		brandLocation: 'Worldwide',
		brandLogo: ethglobal,
		link: 'https://ethglobal.com/'
	},

	{
		brandName: 'buildspace n&w s3 finalist. top 250/7500 projects.',
		brandLocation: 'worldwide',
		brandLogo: buildspace,
		link: 'https://buildspace.so/'
	},

	{
		brandName: 'Andela. Cycle 44 bootcamp finalist. Top 50/5000+. Andela Leaning Community member',
		brandLocation: 'Lagos, Nigeria',
		brandLogo: andela,
		link: 'https://andela.com/'
	},

	{
		brandName: 'Member. GDSC Obafemi Awolowo University',
		brandLocation: 'Obafemi Awolowo University, Ile-Ife',
		brandLogo: google,
		link: 'https://gdsc.community.dev/obafemi-awolowo-university/'
	},

	{
		brandName: 'Member. Startup grind Ife',
		brandLocation: 'Ile-Ife, Nigeria',
		brandLogo: startupgrind,
		link: 'https://www.startupgrind.com/ife/'
	},

	{
		brandName: 'Member. Open Source Community Africa',
		brandLocation: 'Africa',
		brandLogo: osca,
		link: '	https://oscafrica.org/community'
	},
]

export const openSourceList = [{
		brandName: 'Facebook - React',
		brandLogo: react,
		link: 'https://github.com/facebook/react'
	},

	{
		brandName: 'SpaceShard - starknet-devnet',
		brandLogo: shard,
		link: 'https://github.com/0xSpaceShard/starknet-devnet'
	},

	{
		brandName: 'THEmmanuel on GitHub',
		brandLogo: github,
		link: 'https://github.com/THEmmanuel'
	},
]